import { useMutation } from 'react-query';
import { copyFoodMenuByRestId } from 'src/modals/food_details';

export default function useMutateCopyFoodMenu() {
  return useMutation(({ src_rest_id, dst_rest_id }) => {
    return copyFoodMenuByRestId(src_rest_id, dst_rest_id);
  });
}
